module.exports = __webpack_public_path__ + "assets/0d5123586a81b5f330a94f9c33cca0a0.mp3";